module.exports = __webpack_public_path__ + "static/img/patent.0309eab8.png";